module.exports = __webpack_public_path__ + "img/fz.e0059304.jpg";